import { Component, defineComponent } from '@decify/cell-shopify/client';
import './Hotspot.scss';
export const hotspotName = 'Hotspot';
export const hotspotTagName = 'cell-component-hotspot';
export const hotspotClickEvent = 'click';
export class Hotspot extends Component {
    constructor() {
        super(hotspotName);
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount() {
        this.subscribe('click', this.handleClick);
    }
    handleClick() {
        this.publish(hotspotClickEvent);
    }
}
defineComponent(hotspotTagName, Hotspot);
